module.exports = __webpack_public_path__ + "img/starfield_btm_off.73db5310.jpg";